import { useTranslation } from "react-i18next";
import successImage from "../../../../assets/prediction-success.jpg";
import Modal from "../../../../common/Modal";
import styles from "./SuccessModal.module.css";

/**
 * Success modal component for confirming saved predictions
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onClose - Handler for closing the modal
 * @param {number} props.predictionsCount - Number of predictions saved
 * @returns {JSX.Element} - Success modal component
 */
const SuccessModal = ({ isOpen, onClose }) => {
	const { t } = useTranslation();
	// const fansUnitedSDK = useFansUnitedSDK();
	// const [totalOdds, setTotalOdds] = useState(0);

	// Default bet amount
	// const DEFAULT_BET = 10;

	// useEffect(() => {
	// 	if (fansUnitedSDK && currentScores) {
	// 		const matchIds = Object.keys(currentScores);
	// 		getOddsForMatches(matchIds);
	// 	}
	// }, [fansUnitedSDK, currentScores]);

	// const determineResult = (homeScore, awayScore) => {
	// 	if (homeScore > awayScore) return "1";
	// 	if (homeScore < awayScore) return "2";
	// 	return "x";
	// };

	// const calculateTotalOdds = (oddsArray) => {
	// 	if (oddsArray.length === 0) return 0;
	// 	return oddsArray.reduce((acc, match) => acc * match.odds, 1);
	// };

	// const buildOddsUrl = "https://www.betway.com/en/sports#";

	// const getOddsForMatches = async (matchIds) => {
	// 	try {
	// 		const rawOdds = await fansUnitedSDK.odds.getByMatchIds(matchIds, { marketTypes: ["FT_1X2"] });
	// 		// Process the odds data
	// 		const processedOdds = [];

	// 		// Iterate through each match in currentScores
	// 		for (const [matchId, scores] of Object.entries(currentScores)) {
	// 			const { homeTeamScore, awayTeamScore } = scores;
	// 			const prediction = determineResult(homeTeamScore, awayTeamScore);

	// 			// Get odds data for this match
	// 			const matchOddsData = rawOdds.get(matchId);

	// 			if (matchOddsData && matchOddsData.length > 0) {
	// 				// Get the first bookmaker's odds (Betway in this case)
	// 				const bookmakerOdds = matchOddsData[0];

	// 				// Find the market (should be 1x2)
	// 				const market = bookmakerOdds.markets.find((m) => m.type.code === "1x2");

	// 				if (market) {
	// 					// Find the selection based on the prediction
	// 					const selection = market.selections.find((s) => s.code === prediction);

	// 					if (selection) {
	// 						processedOdds.push({
	// 							matchId,
	// 							homeTeamScore,
	// 							awayTeamScore,
	// 							prediction,
	// 							odds: parseFloat(selection.odds),
	// 						});
	// 					}
	// 				}
	// 			}
	// 		}

	// 		const total = calculateTotalOdds(processedOdds);
	// 		setTotalOdds(total);
	// 	} catch (error) {
	// 		console.error("Error fetching odds:", error);
	// 	}
	// };

	return (
		<Modal isOpen={isOpen} onClose={onClose} title="" containerStyle={{ padding: 0 }} hideCloseButton={true}>
			<div className={styles.container}>
				{/* Hero Section with Image */}
				<div className={styles.heroSection}>
					<img src={successImage} alt="Success" className={styles.heroImage} />
				</div>

				{/* Content Section */}
				<div className={styles.contentSection}>
					<h2 className={styles.title}>{t("predictions.successModal.title")}</h2>
					<p className={styles.subtitle}>{t("predictions.successModal.subtitle")}</p>

					{/* <div className={styles.oddsInfo}>
						<p>These are the odds you will receive from Betway, if you place a bet based on the teams you have selected to win:</p>
					</div> */}

					{/* Bet Details */}
					{/* <div className={styles.betDetails}>
						<div className={styles.betRow}>
							<span>Bet: €{DEFAULT_BET}</span>
							<span>Odds: {totalOdds.toFixed(2)}</span>
							<span className={styles.winAmount}>Win: €{(totalOdds * DEFAULT_BET).toFixed(2)}</span>
						</div>
					</div> */}

					{/* Action Button */}
					{/* <button
						className={styles.actionButton}
						onClick={() => {
							window.open(buildOddsUrl, "_blank");
							onClose();
						}}
					>
						Place your bet with Betway
						<svg className={styles.externalIcon} width="16" height="16" viewBox="0 0 16 16" fill="none">
							<path
								d="M12 8.66667V12.6667C12 13.0203 11.8595 13.3594 11.6095 13.6095C11.3594 13.8595 11.0203 14 10.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V5.33333C2 4.97971 2.14048 4.64057 2.39052 4.39052C2.64057 4.14048 2.97971 4 3.33333 4H7.33333"
								stroke="currentColor"
								strokeWidth="1.5"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path d="M10 2H14V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
							<path
								d="M6.66797 9.33333L14.0013 2"
								stroke="currentColor"
								strokeWidth="1.5"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					</button> */}

					{/* Close Button */}
					<button className={styles.closeButton} onClick={onClose}>
						{t("predictions.successModal.close")}
					</button>
				</div>
			</div>
		</Modal>
	);
};

export default SuccessModal;
